import { ProductAlias } from '@ibk/shared-types';
export const selectAllProducts = (state) => state.products;
export const selectProductByAlias = (state, productAlias) => state.products[productAlias];
export const selectContaDigitalProduct = (state) => state.products[ProductAlias.CONTA_DIGITAL];
export const selectCobrancasProduct = (state) => state.products[ProductAlias.COBRANCAS];
export const selectContabilidadeDigitalProduct = (state) => state.products[ProductAlias.CONTABILIDADE_DIGITAL];
export const selectBeneficiosProduct = (state) => state.products[ProductAlias.BENEFICIOS];
export const selectIsAnyProductLoading = (state) => Object.values(state.products).some(product => product.isLoading);
export const selectHasAnyProductError = (state) => Object.values(state.products).some(product => product.error !== null);
export const selectProductData = (state, productAlias) => state.products[productAlias].data;
export const selectProductError = (state, productAlias) => state.products[productAlias].error;
export const selectProductLoading = (state, productAlias) => state.products[productAlias].isLoading;
